<template>
<div class="chapter">
<div class="inner_page">
<p class="pcenter1 also">Also by Thomas F. Monteleone</p>
<p class="pcenter1"><i>Submerged</i></p>
<p class="pcenter"><i>Fearful Symmetries</i></p>
<p class="pcenter"><i>Night Things</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// f002.vue?18ce59a2